/**
 *
 * @param {string} queryString
 */
const queryStringToObject = queryString => {
  const queryObject = {};

  if (queryString) {
    const queryArray = queryString.split('&');
    queryArray.forEach(keyValue => {
      const [key, value] = keyValue.split('=');

      queryObject[key] = value;
    });
  }

  return queryObject;
};

/**
 *
 * @param {object} queryObject
 */
const queryObjectToString = queryObject =>
  Object.keys(queryObject).reduce(
    (queryString, queryKey) =>
      queryString
        ? `${queryString}&${queryKey}=${queryObject[queryKey]}`
        : `${queryKey}=${queryObject[queryKey]}`,
    '',
  );

/**
 * Updates query string of current location without page reload
 * @param newQuery
 */
export const replaceCurrentPageQuery = newQuery => {
  const splitArray = window.location.href.split('?');
  const newUrl = newQuery ? `${splitArray[0]}?${newQuery}` : splitArray[0];

  window.history.replaceState({ path: newUrl }, '', newUrl);
};

/**
 * @param {string} key
 * @param {string} value
 */
export const setQueryParameter = (key, value) => {
  const [url, query] = window.location.href.split('?');
  const queryObject = queryStringToObject(query);
  queryObject[key] = encodeURIComponent(value);
  const newUrl = `${url}?${queryObjectToString(queryObject)}`;

  window.history.replaceState({ path: newUrl }, '', newUrl);
};

export const removeQueryParameter = key => {
  const [url, query] = window.location.href.split('?');
  const queryObject = queryStringToObject(query);

  if (key in queryObject) {
    delete queryObject[key];
    const newUrl = Object.keys(queryObject).length
      ? `${url}?${queryObjectToString(queryObject)}`
      : url;

    window.history.replaceState({ path: newUrl }, '', newUrl);
  }
};

/**
 * Extract query param by name from pathSegment
 * @param {string} name
 * @param {boolean} [ignoreQueryStringPlusSign]
 * @param {string} [pathSegment] - current location by default
 * @returns {null|string}
 */
export const getQueryParameter = (
  name,
  ignoreQueryStringPlusSign = false,
  pathSegment = window.location.href,
) => {
  const processedName = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line

  const regex = new RegExp(`[?&]${processedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(pathSegment);

  if (!results) return null;
  if (!results[2]) return '';

  if (ignoreQueryStringPlusSign) return decodeURIComponent(results[2]);
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getQueryString = () => window.location.href.split('?')[1];
